import { Canvas } from 'fabric';

import { MAX_DATA_SIZE, WARNING_DATA_SIZE } from '../draw-canvas.constants';

export function checkCanvasLimits(canvas?: Canvas | null) {
  if (canvas) {
    const jsonData = JSON.stringify(canvas.toJSON());
    const dataSize = new Blob([jsonData]).size;
    return {
      isWarningReached: dataSize >= WARNING_DATA_SIZE,
      isLimitReached: dataSize >= MAX_DATA_SIZE,
    };
  }
  return {
    isWarningReached: false,
    isLimitReached: false,
  };
}
